module.exports = __webpack_public_path__ + "img/aud.8df21d9e.svg";